/***** Cart subtotal badge – finale versie *****/
(() => {
  if (window.cartSubtotalEnhancerLoaded) return;
  window.cartSubtotalEnhancerLoaded = true;

  /* helpers */
  const toCent  = (txt) => parseInt(txt.replace(/[^\d]/g, ''), 10) || 0;
  const toMoney = (c) => {
  const currency = window.Shopify?.currency?.active || 'USD';
  const localeMap = {
    'USD': 'en-US',
    'GBP': 'en-GB',
    'CAD': 'en-CA',
    'AUD': 'en-AU',
    'NZD': 'en-NZ',
  };
  const locale = localeMap[currency] || window.Shopify?.locale || 'en-US';
  return (c / 100).toLocaleString(locale, { style: 'currency', currency });
};

  /* hoofd­functie */
  function draw() {
    const d = document.getElementById('CartDrawer');
    if (!d) return;

    /* totalen verzamelen – voorkom dubbel tellen */
    let old = 0, now = 0;

    /* 1️⃣ alle actuele prijzen optellen in 'now'
          + in 'old' mee­nemen als er géén strikethrough in dezelfde rij zit */
    d.querySelectorAll('.cart__price:not(.cart__price--strikethrough)')
      .forEach(span => {
        const val = toCent(span.textContent);
        now += val;

        /* zoek binnen dezelfde cart-rij naar een doorgestreepte prijs */
        const row = span.closest('[data-cart-item], .ajaxcart__product, .cart-item, .cart__item, li');
        if (!row || !row.querySelector('.cart__price--strikethrough')) {
          old += val;                 // alleen niet-afgeprijsde items komen hier bij
        }
      });

    /* 2️⃣ alle doorgestreepte prijzen optellen in 'old' */
    d.querySelectorAll('.cart__price--strikethrough')
      .forEach(span => { old += toCent(span.textContent); });

    /* 3️⃣ besparing */
    const save = old - now;


    /* html-targets */
    const oldEl  = d.querySelector('.cart__subtotal--old');
    const nowEl  = d.querySelector('.cart__subtotal--new');
    const saveEl = d.querySelector('.cart__subtotal--save');

    /* actuele totaal – altijd tonen */
    nowEl && (nowEl.textContent = toMoney(now));

    /* alleen tonen wanneer er écht korting is */
    if (save > 0) {
      oldEl  && ((oldEl.textContent  = toMoney(old)),  (oldEl.style.display = ''));
      saveEl && ((saveEl.textContent = '–' + toMoney(save)), (saveEl.style.display = ''));
    } else {
      oldEl  && (oldEl.style.display  = 'none');
      saveEl && (saveEl.style.display = 'none');
    }
  }

  /* micro-throttle: max 1× per animation-frame */
  let busy = false;
  const schedule = () => {
    if (busy) return;
    busy = true;
    requestAnimationFrame(() => { draw(); busy = false; });
  };

  /* MutationObserver – pakt ook de allereerste HTML-injectie */
  const initObserver = () => {
    const d = document.getElementById('CartDrawer');
    if (!d) return;
    new MutationObserver(schedule).observe(d, {
      childList: true,
      subtree:   true
    });
  };

  /* starten zodra mogelijk */
  if (document.readyState !== 'loading') { draw(); initObserver(); }
  else document.addEventListener('DOMContentLoaded', () => { draw(); initObserver(); });

  /* extra triggers op bekende cart-events (voor zekerheid) */
  [
    'cart:updated',
    'ajaxCart:afterUpdate',
    'cart:refresh',
    'mini-cart:updated',
    'CartDrawer:opened'
  ].forEach(e => document.addEventListener(e, schedule));
})();